export const SET_FLEET_CONFIG = '@config/SET_FLEET_CONFIG';
